import { createSlice } from "@reduxjs/toolkit";
import { TipoSorteioModel } from "../../../models/tipoSorteio/tipoSorteioModel";
import { buscarTipoSorteio } from "../../../services/tipoSorteioService";
import { resetAll } from "../../actions/actions";
export interface TipoSorteioState {
  //buscar tipo sorteio
  loading: boolean;
  busca: string | null;
  list: TipoSorteioModel[];
  entity: TipoSorteioModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: TipoSorteioState = {
  //buscar tipo sorteio
  loading: false,
  busca: null,
  list: [],
  entity: {} as TipoSorteioModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const tipoSorteioSlice = createSlice({
  name: "tipoSorteio",
  initialState,
  reducers: {
    //buscar tipo sorteio
    setBuscaTipoSorteio: (state, action) => {
      state.busca = action.payload;
    },
    setEntityTipoSorteio: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarTipoSorteio: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarTipoSorteio: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar tipo sorteio
    builder.addCase(buscarTipoSorteio.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTipoSorteio.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTipoSorteio.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar tipo sorteio
  setBuscaTipoSorteio,
  setEntityTipoSorteio,
  //internal
  setModalCadastrarTipoSorteio,
  setModalDeletarTipoSorteio,
} = tipoSorteioSlice.actions;

export default tipoSorteioSlice.reducer;
